module.exports = __webpack_public_path__ + "static/media/avatar-blank.aed54d11.svg";